export enum KEYS {
	PICK_TOWN = 'townPickerDisabled'
}
